module.exports = __webpack_public_path__ + "static/Banner-31-46e30dd36ea5691e9e0eaf391c7467e5.png";